import React from "react";
import { useNavigate } from "react-router-dom";

const AddDepartmentForm = () => {
    const navigate=useNavigate();
  const departmentstyles = `
    .add-department-wrapper {
      background-color: #f8f9fa;
      min-height: 100vh;
    }

    .form-label {
      font-size: 14px;
    }

    small {
      font-size: 12px;
    }

    input.form-control,
    select.form-select {
      height: 42px;
      font-size: 14px;
    }

    textarea.form-control {
      font-size: 14px;
    }
      .form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}
   .form-select {
    width: 100% !important;
  }
  `;

  return (
    <>
      <style>{departmentstyles}</style>
      <div className="add-department-wrapper container py-4">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-start mb-4">
          <div>
            <h2 className="fw-bold" style={{ fontSize: "20px" }}>
              Add Department
            </h2>
            <p className="text-muted">Create a new department in your clinic</p>
          </div>
          <button className="gradient-dark-button" onClick={()=>{navigate('/Departments')}}>
            ← Back to Departments
          </button>
        </div>

        {/* Form Box */}
        <div className="bg-white rounded shadow-sm p-4">
          <h5 className="fw-semibold">Department Information</h5>
          <p className="text-muted mb-4">
            Enter the details for the new department
          </p>

          <form>
            <div className="row mb-3">
              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">
                  Department Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g. Cardiology"
                />
                <small className="text-muted">
                  The official name of the department
                </small>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">
                  Head of Department
                </label>
                <select className="form-select">
                  <option>Select a doctor</option>
                </select>
                <small className="text-muted">
                  The doctor who will lead this department
                </small>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Location</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g. Building A, Floor 3"
                />
                <small className="text-muted">
                  Physical location of the department
                </small>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Status</label>
                <select className="form-select">
                  <option>Active</option>
                  <option>Inactive</option>
                </select>
                <small className="text-muted">Current operational status</small>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Contact Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="department@clinic.com"
                />
                <small className="text-muted">Department contact email</small>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Contact Phone</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="(555) 123-4567"
                />
                <small className="text-muted">Department contact phone</small>
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Description</label>
              <textarea
                style={{ height: "100px" }}
                className="form-control"
                rows="4"
                placeholder="Provide a description of the department's purpose, specialties, and functions..."
              ></textarea>
              <small className="text-muted">
                Detailed description of the department
              </small>
            </div>
          </form>
          <div className="form-actions">
            <button className="gradient-button">Create Department</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddDepartmentForm;
